import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'
import {
    AdditionalFees,
    LaneFees,
    OutgoingInvoice,
} from 'app/Apps/OrderManagement/Orders/orders.types'
import orderBillingRequests from 'app/requests/Order/OrderBilling.requests'
import orderRequests from 'app/requests/Order/Order.requests'

type Args = {
    orderNumber: string,
    selectedInvoice: OutgoingInvoice,
}

const useGetFeesInfo = ({
    selectedInvoice,
    orderNumber,
}: Args): {
    laneFees: LaneFees,
    additionalFees: AdditionalFees,
} => {
    const requestFuncLaneFees = selectedInvoice
        ? orderBillingRequests.getLaneFees
        : orderRequests.getLaneFeesByOrder
    const requestFuncAdditionalFees = selectedInvoice
        ? orderBillingRequests.getAdditionalFees
        : orderRequests.getAdditionalFeesByOrder
    const {
        data: laneFees,
    } = useRequest<LaneFees>({
        key: RequestKeys.getLaneFees,
        params: {
            outgoingInvoiceId: selectedInvoice?.id,
            orderNumber,
        },
        requestFunc: RequestFn.getEntity(requestFuncLaneFees),
        enabled: Boolean(selectedInvoice || orderNumber),
    })

    const {
        data: additionalFees,
    } = useRequest<AdditionalFees>({
        key: RequestKeys.getAdditionalFees,
        params: {
            outgoingInvoiceId: selectedInvoice?.id,
            orderNumber,
        },
        requestFunc: RequestFn.getEntity(requestFuncAdditionalFees),
        enabled: Boolean(selectedInvoice || orderNumber),
    })

    return {
        laneFees,
        additionalFees,
    }
}

export default useGetFeesInfo
